module.exports = __webpack_public_path__ + "img/1.d0061e62.jpg";